export default __webpack_public_path__ + "static/media/1986.e5c7bc60.png";